function toMessage(err: unknown): string {
  if (err instanceof Error) {
    return err.message;
  }
  if (typeof err === 'string') {
    return err;
  }
  return JSON.stringify(err ?? '');
}

export function isNetworkError(err: unknown): boolean {
  //navigator.online geeft aan of de browser internet connectie heeft
  if (typeof navigator !== 'undefined' && !navigator.onLine) {
    return true;
  }

  const message = toMessage(err);
  return /failed to fetch|load failed|network ?error|network request failed|net::err_[a-z_]+/i.test(message);
}
